import * as React from "react";
const SvgBold01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.965 16A2.965 2.965 0 0 0 15 13.035H7.035v5.93H15A2.965 2.965 0 0 0 17.965 16m-1-8A2.965 2.965 0 0 0 14 5.035H7.035v5.93H14A2.965 2.965 0 0 0 16.965 8m2.07 0c0 1.424-.593 2.71-1.544 3.625A5.035 5.035 0 0 1 15 21.035H6A1.035 1.035 0 0 1 4.965 20V4c0-.572.463-1.035 1.035-1.035h8A5.035 5.035 0 0 1 19.035 8"
}));
export default SvgBold01;
//# sourceMappingURL=Bold01.js.map